<template>
    <div>
        <div class="change-vehicle" v-if="(productAvailabilityStatus == 4) && (PhotoRequiredBannerContent != '')">
            <p><strong>{{ label_vehicle_photo_shoot_promotion }}</strong></p>
            <p v-html="PhotoRequiredBannerContent"></p>
        </div>
        <div class="change-vehicle" v-if="(productAvailabilityStatus == 5) && promoContent && (promoContent != '')">
            <p v-html="promoContent" style="margin-bottom: 0.5rem;"></p>
        </div>
        <div class="change-vehicle" v-if="(productAvailabilityStatus == 3)">
            <p><strong>Vehicle Test Fitment Promotion</strong></p>
            <p v-if="testFitmentBannerContent" v-html="testFitmentBannerContent"></p>
            <p v-else> Not available for your vehicle. </p>
        </div>
        <div class="change-vehicle" v-if="productAvailabilityStatus == 2">
            <p style="margin-bottom: 0.5rem;">Fit is coming soon!</p>
        </div>
        <div class="select-text">Select Product Category</div>
        <div class="row">
            <div
                v-for="(item, solutionIndex) in solutionItems"
                :key="solutionIndex"
                class="solution-item col-12"                
                :class="[(selectedVehicle.hasWorkSolution && (solutionItems.length > 2)) ? 'col-lg-4' : 'col-lg-6']"
                >
                <solution-item-new
                    :item="item"
                    v-on:showCategories="$emit('showCategories', item)"
                    :label_na_for_your_vehicle="label_na_for_your_vehicle"
                    :label_begin="label_begin"
                    >
                </solution-item-new>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "solution-items",
    data() {
        return {
            PhotoRequiredBannerContent: "",
            productAvailabilityStatus: "",
            testFitmentBannerContent : "",
            promoMessageContent : "",
        };
    },
    props: {
        selectedVehicle: {
            type: Object
        },
        solutionItems: {
            type: Array
        },
        label_manufacturer: {
            type: String,
            default: "Manufacturer"
        },
        label_model: {
            type: String,
            default: "Model"
        },
        label_year: {
            type: String,
            default: "Year"
        },
        label_body_type: {
            type: String,
            default: "Body Type"
        },
        label_loading: {
            type: String,
            default: "Loading"
        },
        label_select: {
            type: String,
            default: "Select"
        },
        label_select_vehicle: {
            type: String,
            default: "Select Vehicle"
        },
        your_vehicle_is_set_to: {
            type: String,
            default: "Your vehicle is set to"
        },
        label_vehicle_photo_shoot_promotion: {
            type: String,
            default: "Vehicle Photo Shoot Promotion"
        },
        label_na_for_your_vehicle: {
            type: String,
            default: "Not available for your vehicle"
        },
        label_begin: {
            type: String,
            default: "Begin"
        },
    },
    mounted() { 
            this.getPhotoRequiredBannerContent();        
    },
    methods: {
        async getPhotoRequiredBannerContent() {
            let response = await axios.get(
                "/" + window.culture + "/api/getPhotoRequiredBannerContent/" + this.selectedVehicle.vehicleId
            );
            if(response.data && response.data.data)
            {
            this.PhotoRequiredBannerContent = response.data.data.photoRequiredBannerContent;
            this.testFitmentBannerContent = response.data.data.testFitmentBannerContent;
            this.promoContent = response.data.data.promoContent;
            this.productAvailabilityStatus = response.data.data.productAvailabilityStatus;
            }
                   
        },
        redirectToForm(){
            if((this.productAvailabilityStatus == 3) && (!this.anyAvailable)) window.location.href = "/"+window.culture+"/70-percent-off";
        }
    },
    computed: {
        anyAvailable: function() {
            let available = false;

            this.solutionItems.forEach(element => {
                if (element.product_count > 0) {
                    available = true;
                }
            });
            return available;
        }
    },
    watch : {
        solutionItems : function(newVal, oldVal) {
            //this.redirectToForm();
        }
    }
};
</script>
